/**
 * Retrieval API Service
 * 
 * This module contains API functions for retrieval operations
 * including request creation, approval, and status management.
 */

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://khazenly.isnc-logistics.com';

const retrievalAPI = {
  /**
   * Request retrieval for an order
   */
  async requestRetrieval(token, orderId, deliveryAddress, deliveryDate) {
    const response = await fetch(`${API_BASE_URL}/api/retrieval/request`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        order_id: orderId,
        delivery_address: deliveryAddress,
        delivery_date: deliveryDate
      })
    });

    if (!response.ok) {
      throw new Error('Failed to request retrieval');
    }

    return response.json();
  },

  /**
   * Approve a retrieval request
   */
  async approveRetrieval(token, orderId, adminNotes = '') {
    const response = await fetch(`${API_BASE_URL}/api/retrieval/${orderId}/approve`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        admin_notes: adminNotes
      })
    });

    if (!response.ok) {
      throw new Error('Failed to approve retrieval');
    }

    return response.json();
  },

  /**
   * Start retrieval delivery
   */
  async startDelivery(token, orderId, adminNotes = '') {
    const response = await fetch(`${API_BASE_URL}/api/retrieval/${orderId}/start-delivery`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        admin_notes: adminNotes
      })
    });

    if (!response.ok) {
      throw new Error('Failed to start delivery');
    }

    return response.json();
  },

  /**
   * Complete retrieval
   */
  async completeRetrieval(token, orderId, adminNotes = '') {
    const response = await fetch(`${API_BASE_URL}/api/retrieval/${orderId}/complete`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        admin_notes: adminNotes
      })
    });

    if (!response.ok) {
      throw new Error('Failed to complete retrieval');
    }

    return response.json();
  },

  /**
   * Get all retrieval requests
   */
  async getRetrievalRequests(token, limit = 100, skip = 0) {
    const response = await fetch(`${API_BASE_URL}/api/retrieval/requests?limit=${limit}&skip=${skip}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch retrieval requests');
    }

    return response.json();
  },

  /**
   * Get pending retrieval requests
   */
  async getPendingRetrievalRequests(token) {
    const response = await fetch(`${API_BASE_URL}/api/retrieval/pending`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch pending retrieval requests');
    }

    return response.json();
  },

  /**
   * Get retrieval statistics
   */
  async getRetrievalStats(token) {
    const response = await fetch(`${API_BASE_URL}/api/retrieval/stats`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch retrieval stats');
    }

    return response.json();
  }
};

export { retrievalAPI };
